<template lang="html">
  <div class="problemDetails">
    <Header :openTarget="'question/detail?id=' + question.question_id" />
    
    <div class="teacherCon">
      <div class="teacherCard">
        <div class="teacherInfo">
          <div class="teacherAvatar">
            <img :src="question.teacher_avatar" alt="" class="teacherAvatarImg">
            <img src="@/assets/image/icon/tv.png" alt="" class="teacherMark">
            
            <WxOpenTag ref="wxopentag" :extinfo="'question/detail?id=' + question.question_id" />
          </div>
      
          <div class="teacherGrade" v-if="question.teacher.average_score || question.teacher.response_rate">
            <div v-if="question.teacher.average_score">
              <Rating :comment='question.teacher.average_score'/>
            </div>
            <div v-else> 暂无评分 </div>
            <div class="responseRate"  v-if="question.teacher.response_rate">应答率 {{question.teacher.response_rate}}%</div>
            <div class="responseRate" v-else> 暂无评分 </div>
          </div>
          <div class="teacherGrade" v-else>
            暂无评分
          </div>
        </div>
        <div class="teacherConsultBtn">
          {{question.price}}巢币 咨询
          
          <WxOpenTag ref="wxopentag" :extinfo="'question/detail?id=' + question.question_id" />
        </div>
      </div>
      
      <div class="answerHint">
        <p class="answerCon">价值 {{question.price}}巢币</p>
        <p class="xian"></p>
        <p class="answerCon"> 看答案：{{question.answer_price}}巢币({{question.look_answer_num}}人)</p>
      </div>
    </div>
    
    <div class="questionCon">
      <div class="questionUser">
        <div class="questionUserInfo">
          <img :src="question.avatar" alt="">
          <p>{{question.username}}</p>
        </div>
        <p class="questionTime">{{question.show_end_time}}</p>
      </div>
      
      <div class="questionCard">
        {{question.question_content}}
      </div>
      
      <div class="questionImg" v-if="question.video_cover">
        <div class="questionVideo">
          <img :src="question.video_cover" alt="" class="videoCover">
          <img src="../../assets/image/icon/playBtn.png" alt="" class="videoBtn">
        </div>
        <img alt="" v-for="(a, index) in question.imgs.slice(0,2)" :key="index" :src="a" class="elseImg">
        <div class="allImgBtn" v-if="question.imgs.length > 2">          
          +{{question.imgs.length - 2}}
        </div>
      </div>
      <div class="questionImg" v-else>
        <img alt="" v-for="(a, index) in question.imgs.slice(0,3)" :key="index" :src="a" class="elseImg">
        <div class="allImgBtn" v-if="question.imgs.length > 2">          
          +{{question.imgs.length - 3}}
        </div>
      </div>
      
      <div class="teacherAnswer">
        <div class="teacherAnswerCard">
          <img :src="question.teacher_avatar" alt="" class="teacherAvatarImg">
          <img src="@/assets/image/icon/tv.png" alt="" class="teacherMark">
        </div>
        
        <p class="teacherAnswerName">{{question.teacher_username}}的回答</p>
      </div>
      
      <p class="callAppText">快登录APP查看答案吧～</p>
      
      <WxOpenTag ref="wxopentag" :extinfo="'question/detail?id=' + question.question_id" />
    </div>
    
    <div class="callAppIcon">
      <img src="../../assets/image/icon/download.png" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'question/detail?id=' + question.question_id" />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/HeadModule';
  import Rating from '@/components/Rating';
  import WxOpenTag from '@/components/WxOpenTag';

  export default {
    data() {
      return {
        question: {
          teacher: {},
          imgs: [],
        },
      }
    },

    components: {
      Header,
      Rating,
      WxOpenTag,
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getQuestionInfo()
      },

      getQuestionInfo() {
        this.$http({
          url: '/question/getQuestionInfo',
          method: 'get',
          params: {
            question_id: this.$route.query.qid,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.question = res.data;
            document.title = this.question.username + '提出的疑问咨询';
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .problemDetails {
    width: 100%;
    height: 100%;
    background-color: #F7F8F8;   
  }
  
  .teacherCon {
    box-sizing: border-box;
    background-color: #FFFFFF;
    padding: 1.5rem;
  }
  
  .teacherCard {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .teacherInfo {
    display: flex;
    align-items: center;
  }

  .teacherAvatar {
    position: relative;
    margin-right: 1.25rem;
  }

  .teacherAvatarImg {
    width: 5rem;
    height: 5rem;
    object-fit: cover;
    border-radius: 50%;
  }
  
  .teacherMark {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 1.7rem;
    height: 1.7rem;
  }
  
  .teacherName {
    font-size: 1.6rem;
    color: #333333;
    font-weight: 600;
  }
  
  .teacherGrade {
    display: flex;
    align-items: center;
    margin-top: .8rem;
    font-size: 1.2rem;
    color: #777777;
  }
  
  .responseRate {
    font-size: 1.2rem;
    color: #777777;
    margin-left: 1rem;
  }
  
  .openQuestionCon {
    margin-top: 1rem;
    background-color: #FFFFFF;
  }
  
  .teacherConsultBtn {
    position: relative;
    width: 8.7rem;
    height: 2.9rem;
    background-color: #F7443F;
    border-radius: 2.9rem;
    color: #FFFFFF;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .answerHint {
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to right, #FAF4F2, #F3F7FA);
    margin-top: .95rem;
  }
  
  .answerCon {
    width: 48%;
    font-size: 1.4rem;
    color: #333333;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .xian {
    width: .05rem;
    height: 2.25rem;
    background-color: #AFBAC5;
    margin: 0 .5rem;
  }
  
  .questionCon {
    position: relative;
    box-sizing: border-box;
    margin-top: 1rem;
    background-color: #FFFFFF;
    padding: 1.5rem;
  }
  
  .questionUser {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .questionUserInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .questionUserInfo img {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 1rem;
  }
  
  .questionUserInfo p {
    font-size: 1.4rem;
    font-weight: 600;
    color: #333333;
  }
  
  .questionTime {
    font-size: 1.2rem;
    color: #999999;
  }
  
  .questionCard {
    font-size: 1.4rem;
    color: #555555;
    margin-top: .8rem;
  }
  
  .questionImg {
    position: relative;
    margin-top: .8rem;
    display: flex;
  }
  
  .questionVideo {
    position: relative;
    width: 11rem;
    height: 11rem;
  }
  
  .videoCover {
    width: 11rem;
    height: 11rem;
    border-radius: .5rem;
    object-fit: cover;
  }
  
  .videoBtn {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 2.7rem;
    height: 2.7rem;
    margin-left: -1.4rem;
    margin-top: -1.4rem;
  }
  
  .elseImg {
    width: 11rem;
    height: 11rem;
    border-radius: .5rem;
    object-fit: cover;
    margin-left: .75rem;
  }
  
  .allImgBtn {
    position: absolute;
    top: 50%;
    right: 2.55rem;
    margin-top: -1.5rem;
    width: 5.75rem;
    height: 3rem;
    border-radius: 3rem;
    background-color: rgba(255, 255, 255, 0.38);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2.15rem;
    font-weight: 600;
    color: #FFFFFF;
  }
  
  .teacherAnswer {
    margin-top: 2.3rem;
    display: flex;
    align-items: center;
  }
  
  .teacherAnswerCard {
    position: relative;
    width: 3.3rem;
    height: 3.3rem;
  }
  
  .teacherAnswerCard > .teacherAvatarImg {
    width: 3.3rem;
    height: 3.3rem;
  }
  
  .teacherAnswerCard > .teacherMark {
    width: 1.2rem;
    height: 1.2rem;
  }
  
  .teacherAnswerName {
    font-size: 1.4rem;
    color: #333333;
    font-weight: 600;
    margin-left: 1rem;
  }
  
  .callAppText {
    display: flex;
    justify-content: center;
    padding-top: 3rem;
    font-size: 1.4rem;
    color: #333333;
  }
  
  .callAppIcon {
    position: fixed;
    right: 0;
    bottom: 20%;
    z-index: 10;
  }
  
  .callAppIcon img {
    width: 7rem;
    height: 4.4rem;
  }
</style>
